<div class="content">
  <div class="decision-blocks">
    <h2 class="modal-window" [innerHTML]="'create bespoke letter'"></h2>
    <p style="text-align: left">Select your <strong>decision</strong></p>
    <div
      class="decision-block green"
      [ngClass]="{ active: decision === decisionsConst.upheld.id }"
      (click)="changeDecisionStatus(decisionsConst.upheld.id)"
    >
      <span>uphold PCN</span>
    </div>
    <div
      class="decision-block blue"
      [ngClass]="{ active: decision === decisionsConst.reqInfo.id }"
      (click)="changeDecisionStatus(decisionsConst.reqInfo.id)"
    >
      <span>request info</span>
    </div>
    <div
      class="decision-block red"
      [ngClass]="{ active: decision === decisionsConst.cancel.id }"
      (click)="changeDecisionStatus(decisionsConst.cancel.id)"
    >
      <span>cancel PCN</span>
    </div>
  </div>
  <div class="reason-decision-blocks">
    <div class="reason-decision-block request-info">
      <div class="bespoke-letter" style="display: inline-block">
        <div class="letter-label" style="width: 100%">
          <p>Type your <strong>explanation</strong>, if you need one.</p>
        </div>
        <div class="letter" style="width: 100%; text-align: left">
          <ckeditor [(ngModel)]="explanation" [config]="ckeConfig" debounce="500"> </ckeditor>
        </div>
      </div>

      <div *ngIf="decision === decisionsConst.reqInfo.id">
        <div class="subtitle">
          <br /><br />
          <p>Type your <strong>documentary evidence</strong> requirements.</p>
          Response Master will create this paragraph:
          <br />
          <i
            >We will reconsider your case if you send us *. You need to do this within 14 days of
            the date of this letter. Please send a photocopy (not the original) and quote your
            parking ticket number (see above).</i
          >
          <br /><br />
          In the box below, type the words you want in place of the *. Don't put a full-stop at the
          end – Response Master will. Example: a letter from your dentist about the operation
        </div>
        <textarea class="small" [(ngModel)]="infoDetails"></textarea>
      </div>
      <div class="cancel-fields" *ngIf="decision === decisionsConst.cancel.id">
        <p style="text-align: left">Are we cancelling this PCN because the CEO made a mistake?</p>
        <label
          class="question-label radio"
          *ngFor="let option of cancelOptions.optionList"
          [ngClass]="{ selected: option.id === cancelOptions.optionSelected }"
          (click)="cancelOptions.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>

      <div
        class="cancel-fields"
        *ngIf="decision === decisionsConst.cancel.id && bespokeFieldsObject.encloseRefund"
      >
        <p style="text-align: left">Are you going to enclose the payment the driver sent in?</p>
        <label
          class="question-label radio"
          *ngFor="let option of encloseRefund.optionList"
          [ngClass]="{ selected: option.id === encloseRefund.optionSelected }"
          (click)="encloseRefund.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>

      <div
        class="cancel-fields"
        *ngIf="decision !== decisionsConst.cancel.id && bespokeFieldsObject.pinNumber"
      >
        <p style="text-align: left">
          Would you like the letter to contain a PIN number for an online appeal?
        </p>
        <label
          class="question-label radio"
          *ngFor="let option of pinNumber.optionList"
          [ngClass]="{ selected: option.id === pinNumber.optionSelected }"
          (click)="pinNumber.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>

      <div
        class="cancel-fields"
        *ngIf="decision !== decisionsConst.cancel.id && bespokeFieldsObject.tpt"
      >
        <p style="text-align: left">
          {{ bespokeFieldsObject.tptText }}
        </p>
        <label
          class="question-label radio"
          *ngFor="let option of tpt.optionList"
          [ngClass]="{ selected: option.id === tpt.optionSelected }"
          (click)="tpt.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>

      <div
        class="cancel-fields"
        *ngIf="decision !== decisionsConst.cancel.id && bespokeFieldsObject.tptWebPortal"
      >
        <p style="text-align: left">
          {{ bespokeFieldsObject.tptWebPortalText }}
        </p>
        <label
          class="question-label radio"
          *ngFor="let option of tptWebPortal.optionList"
          [ngClass]="{ selected: option.id === tptWebPortal.optionSelected }"
          (click)="tptWebPortal.optionSelected = option.id"
        >
          <i class="radio-icon"></i>
          <span [innerHTML]="option.caption"></span>
          <input aria-label="" [value]="option.id" type="radio" />
        </label>
      </div>
    </div>
    <div class="buttons">
      <button class="cancel secondary" (click)="onCloseModal()">
        <span>Cancel</span>
        <!-- <img [src]="constants.assetsPath + '/img/icons/red-bin.svg'" width="14"> -->
      </button>
      <button
        class="change"
        [disabled]="!isBespokeLetterAllowed()"
        (click)="onSubmitBespokeLetter()"
      >
        <span [innerHTML]="'create bespoke letter'"></span>
      </button>
    </div>
  </div>
</div>
